export default __webpack_public_path__ + "static/media/video-blue-icon.5e3227d3.png";